import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { CheckboxWrapper, CheckboxInput, CheckboxInputLabel } from './Checkbox.styles.js';
import COLORS from '../../constants/colors.js';

const Checkbox = forwardRef((props, ref) => {
    const { id = `radio-${props.name}-${props.index}`, fillColor = COLORS.BLUE, label, name, value, disabled, index, onChange, checkboxWrapperClass, checkBoxClass, checkBoxLabelClass, size = "sm", alignItems = "flex-start", labelProps, } = props;
    return (jsxs(CheckboxWrapper, Object.assign({ className: checkboxWrapperClass, alignItems: alignItems }, { children: [jsx(CheckboxInput, { type: "checkbox", id: id, checked: value, disabled: disabled, name: name, onChange: onChange, 
                // SC Props
                fillColor: fillColor, className: checkBoxClass, size: size }), jsx(CheckboxInputLabel, Object.assign({}, labelProps, { className: checkBoxLabelClass, htmlFor: id }, { children: label }))] })));
});

export { Checkbox as default };
//# sourceMappingURL=Checkbox.js.map
